import { uploadIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const Upload = createIcon({
  displayName: 'Upload',
  paths: [
    'M481.839 183.179c16.683-16.683 43.648-16.683 60.331 0l181.035 181.035c16.64 16.64 16.64 43.648 0 60.331-16.683 16.638-43.691 16.638-60.331 0l-108.203-108.203v323.667c0 23.552-19.115 42.667-42.667 42.667s-42.667-19.115-42.667-42.667v-323.667l-108.205 108.203c-16.64 16.638-43.648 16.638-60.331 0-16.64-16.683-16.64-43.691 0-60.331l181.037-181.035zM853.333 640c0-23.552 19.115-42.667 42.667-42.667s42.667 19.115 42.667 42.667v170.667c0 23.552-19.115 42.667-42.667 42.667h-768c-23.552 0-42.667-19.115-42.667-42.667v-170.667c0-23.552 19.115-42.667 42.667-42.667s42.667 19.115 42.667 42.667v128h682.667v-128z'
  ],
  canvasPaths: canvasIconPaths(uploadIcon)
})
